import { render, staticRenderFns } from "./termsAndConditions.vue?vue&type=template&id=81874bf2"
import script from "./termsAndConditions.vue?vue&type=script&lang=js"
export * from "./termsAndConditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports